var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 70,
    viewBox: "0 0 53 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26659 2.05904C8.12939 2.05904 7.20751 2.98091 7.20751 4.11808V9.26386H36.0346V4.11808C36.0346 2.98091 35.1127 2.05904 33.9755 2.05904H9.26659ZM5.14844 4.11808C5.14844 1.84373 6.9922 0 9.26659 0H33.9755C36.2499 0 38.0936 1.84373 38.0936 4.11808V11.3229H5.14844V4.11808Z",
    fill: "#1B1E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2363 9.26575H35.0043V15.443H38.0929C40.9359 15.443 43.2406 17.7477 43.2406 20.5907V53.5359H41.1815V20.5907C41.1815 18.8849 39.7987 17.502 38.0929 17.502H32.9452V11.3248H10.2954V17.502H5.14769C3.44189 17.502 2.05907 18.8849 2.05907 20.5907V59.7131C2.05907 61.4189 3.44189 62.8017 5.14769 62.8017H21.6203V64.8608H5.14769C2.3047 64.8608 0 62.5561 0 59.7131V20.5907C0 17.7477 2.3047 15.443 5.14769 15.443H8.2363V9.26575Z",
    fill: "#1B1E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9325 44.079V46.1074H12.3442C11.207 46.1074 10.2852 45.1856 10.2852 44.0484V28.6053C10.2852 27.4681 11.207 26.5462 12.3442 26.5462H42.9325V28.5746L42.9328 28.6053V44.0484L42.9325 44.079ZM41.4912 27.9876H12.3442C12.0031 27.9876 11.7265 28.2642 11.7265 28.6053V44.0484C11.7265 44.3895 12.0031 44.6661 12.3442 44.6661H41.4912V44.058L41.4914 44.0484V28.6053L41.4913 28.5957L41.491 28.5746L41.4912 27.9876Z",
    fill: "#1B1E59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7383 63.8272C25.7383 60.418 28.502 57.6543 31.9112 57.6543H46.3333C49.7425 57.6543 52.5063 60.418 52.5063 63.8272V63.8272C52.5063 67.2365 49.7425 70.0002 46.3333 70.0002H31.9112C28.502 70.0002 25.7383 67.2365 25.7383 63.8272V63.8272Z",
    fill: "#05F29B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3333 59.7134H31.9112C29.6392 59.7134 27.7974 61.5552 27.7974 63.8272C27.7974 66.0993 29.6392 67.9411 31.9112 67.9411H46.3333C48.6053 67.9411 50.4472 66.0993 50.4472 63.8272C50.4472 61.5552 48.6053 59.7134 46.3333 59.7134ZM31.9112 57.6543C28.502 57.6543 25.7383 60.418 25.7383 63.8272C25.7383 67.2365 28.502 70.0002 31.9112 70.0002H46.3333C49.7425 70.0002 52.5063 67.2365 52.5063 63.8272C52.5063 60.418 49.7425 57.6543 46.3333 57.6543H31.9112Z",
    fill: "#1B1E59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0913 70.0002V57.6543H40.1504V70.0002H38.0913Z",
    fill: "#1B1E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPharmacy);
export default __webpack_public_path__ + "static/media/Icon_Pharmacy.f7760280ac36242c746a339bdb71716f.svg";
export { ForwardRef as ReactComponent };